import { db } from "./Firebase"

const tblProducts   = 'products'
const tblCategories = 'categories'

export default {
   getRef() {
      return db().ref(tblProducts)
   },
   getProductById(id) {
      return db().ref(tblProducts).child(id).once('value')
   },
   storeProduct(obj) {
      let timestamp     = new Date().getTime()
      let newProductKey = db().ref(tblProducts).push().key

      let productData = {
         id             : newProductKey,
         code           : obj.code,
         name           : obj.name,
         src            : "",
         price          : obj.price,
         discount_rate  : obj.discount_rate,
         discount_amount: obj.discount_amount,
         sale_price     : obj.sale_price,
         offer_status   : obj.offer_status,
         status         : obj.status ? '1' : '0',
         category_id    : obj.category_id != null ? obj.category_id : '',
         created_at     : timestamp,
         updated_at     : timestamp,
      }
      let updates = {}
      updates[`/${tblProducts}/${newProductKey}`] = productData
      if (obj.category_id != '') {
         updates[`/${tblCategories}/${obj.category_id}/products/${newProductKey}`] = true
      }

      return db().ref().update(updates)
   },
   updateProduct(obj, oldCategoryId) {
      let timestamp     = new Date().getTime()

      let productData = {
         id             : obj.id,
         code           : obj.code,
         name           : obj.name,
         src            : obj.src,
         price          : obj.price,
         discount_rate  : obj.discount_rate,
         discount_amount: obj.discount_amount,
         sale_price     : obj.sale_price,
         offer_status   : obj.offer_status,
         status         : obj.status ? '1'   : '0',
         category_id    : obj.category_id != null ? obj.category_id : '',
         created_at     : obj.created_at,
         updated_at     : timestamp,
      }

      let updates = {}
      updates[`/${tblProducts}/${obj.id}`] = productData

      if (obj.category_id != oldCategoryId) {
         if (oldCategoryId != "") {
            updates[`/${tblCategories}/${oldCategoryId}/products/${obj.id}`] = null
         }
         if (obj.category_id != "") {
            updates[`/${tblCategories}/${obj.category_id}/products/${obj.id}`] = true
         }
      }

      return db().ref().update(updates)
   },
   updateStatus(obj){
      let timestamp = new Date().getTime()

      let productData = {
         status    : obj.status ? '1': '0',
         updated_at: timestamp
      }

      return db().ref(tblProducts).child(obj.id).update(productData)
   },
   deleteProduct(id,categoryId) {
      let updates = {}
      updates[`/${tblProducts}/${id}`] = null
      updates[`/${tblCategories}/${categoryId}/products/${id}`] = null

      return db().ref().update(updates)
   }
}
